module.exports = __webpack_public_path__ + "img/pen_edit.7c5795ea.svg";